import React, { useEffect, useMemo, useState } from 'react';

import i18n from 'I18n';

import CustomButton from 'component/base/CustomButton';
import CustomModal from 'component/base/CustomModal';

import ConfirmField from './ConfirmField';

import { ADDITIONAL_DATA_TYPE } from 'utils/CustomEnums';

import { ReactComponent as Checked } from 'assets/checkbox-checked.svg';
import { ReactComponent as Unchecked } from 'assets/checkbox-unchecked.svg';

const OtherInfoSelectionField = ({
  language,
  question = {},
  isConfirm,
  editAction,
}) => {
  const {
    title,
    placeholder,
    defaultValue,
    fieldName,
    options: sections,
    questionFormat,
    optional,
  } = question;
  const isSingleSection =
    questionFormat === ADDITIONAL_DATA_TYPE.SINGLE_CHOICES;

  const [showModal, setShowModal] = useState(false);
  const [inputValue, setInputValue] = useState([]);

  const resetInputValue = () => {
    if (!!defaultValue) {
      setInputValue(defaultValue.split(','));
    } else {
      setInputValue([]);
    }
  };

  useEffect(() => {
    resetInputValue();
  }, [defaultValue]);

  const displayValue = useMemo(() => {
    if (!defaultValue) {
      return placeholder;
    }
    const valueList = defaultValue.split(',');
    const resultList = valueList?.flatMap((item) => {
      const label = sections?.find((section) => section.value === item)?.label;
      if (label || label === 0 || label === '0') {
        return [label];
      }
      return [];
    });
    return resultList.join(', ');
  }, [defaultValue, sections]);

  const onEdit = (value) => {
    editAction(fieldName, value);
  };

  const onClose = () => {
    resetInputValue();
    setShowModal(false);
  };

  if (isConfirm) {
    return <ConfirmField value={displayValue} />;
  }

  return (
    <div>
      <div
        className="other_info_selection_text"
        onClick={() => {
          setShowModal(true);
        }}
      >
        <ConfirmField value={displayValue} />
      </div>
      <CustomModal
        className={'additional-data-modal'}
        title={title}
        show={showModal}
        tabs={[
          {
            name: '',
            content: (
              <div>
                <div className="additional-data-choices-scrollable-contaniner">
                  {sections?.map((choice) => {
                    const checked = inputValue.includes(choice.value);
                    return (
                      <div
                        className="field-text additional-field-choice"
                        onClick={() => {
                          if (isSingleSection) {
                            setInputValue([choice.value]);
                            return;
                          }
                          if (checked) {
                            const selectItem = inputValue?.filter(
                              (item) => item !== choice.value,
                            );
                            setInputValue(selectItem);
                            return;
                          }
                          setInputValue([...inputValue, choice.value]);
                        }}
                      >
                        {checked ? <Checked /> : <Unchecked />}
                        <div style={{ wordBreak: 'break-all' }}>
                          {choice.label}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <CustomButton
                  btnClicked={() => {
                    onEdit(inputValue.join(',') || '');
                    setShowModal(false);
                  }}
                  disabled={!optional && inputValue.length < 1}
                  text={i18n.t('account_update')}
                />
              </div>
            ),
          },
        ]}
        hideTab={true}
        onClose={onClose}
      />
    </div>
  );
};

export default OtherInfoSelectionField;
